import { useEffect } from 'react';

export default function AdSenseScript() {
  useEffect(() => {
    const id = process.env.REACT_APP_ADSENSE_ID;
    if (!id || document.getElementById('adsense-script')) return;
    const s = document.createElement('script');
    s.id = 'adsense-script';
    s.async = true;
    s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${id}`;
    s.crossOrigin = 'anonymous';
    document.head.appendChild(s);
  }, []);
  return null;
}
